import { action, extendObservable } from 'mobx';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';
import FlagStore from './FlagStore';
import UrlBulkEditorStore from './UrlBulkEditorStore';
import urlPatternValidator, { normalizeUrlPattern } from '../urlPatternValidator';

export default class UrlBulkEditorCardStore {
    static PropType = PropTypes.shape({
        guidelines: FlagStore.PropType.isRequired,
        urlBulkEditorStore: UrlBulkEditorStore.PropType.isRequired,
        validators: MobxPropTypes.arrayOrObservableArrayOf(PropTypes.func),
    });

    constructor(data = {}) {
        extendObservable(this, /** @class UrlBulkEditorCardStore */{
            guidelines: new FlagStore(false),
            urlBulkEditorStore: new UrlBulkEditorStore({
                ...(data.validators ? { validators: data.validators } : {}),
                getCanonicalValue: normalizeUrlPattern,
            }),
            hasChanged() {
                return this.urlBulkEditorStore.bulkEditorStore.hasChanged();
            },
            isValid() {
                return this.urlBulkEditorStore.bulkEditorStore.isValid();
            },
            isEmpty() {
                // Note = urlPatterns contains an empty string and is length 1 when cleared.
                // getValue removes that.
                return this.getValue().length === 0;
            },
        }, data);
        // Init bulk editor
        if (data.validators) {
            return;
        }
        this.setValidator(data.validator || urlPatternValidator);
    }

    getValue = () => {
        const fixedUrls = new Set(this.urlBulkEditorStore.bulkEditorStore.urlPatterns
            .filter((value) => !!value)
            .map((value) => normalizeUrlPattern(value)));

        return Array.from(fixedUrls.values());
    };

    getValidators = () => {
        return this.urlBulkEditorStore.bulkEditorStore.validators;
    }

    setValue = (data) => {
        this.urlBulkEditorStore.bulkEditorStore.setUrlPatterns(data);
    };

    setValidator = action((validator) => {
        this.urlBulkEditorStore.bulkEditorStore.validator = validator;
    });
}
